/**Dependencies */
import { Routes, Route, useLocation } from "react-router-dom";

/**Views */
import { Home } from "./views/Home";
import { Alojamientos } from "./views/Alojamientos";
import { Hotel } from "./views/Hotel";
import { Circuitos } from "./views/Circuitos";
import { Cursos } from "./views/Cursos";
import { Destinos } from "./views/Destinos";
import { Promociones } from "./views/Promociones";
import { Cruceros } from "./views/Cruceros";
import { Sandals } from "./views/Sandals";
import { MesaRegalos } from "./views/MesaRegalos";
import { SeguroViajero } from "./views/SeguroViajero";
import { XvAños } from "./views/XvAños";
import { Nosotros } from "./views/Nosotros";
import { Contacto } from "./views/Contacto";
import { Terminos } from "./views/Terminos";
import { AvisoPrivacidad } from "./views/AvisoPrivacidad";
import { PoliticaCookies } from "./views/PoliticaCookies";
import { PreguntasFrecuentes } from "./views/PreguntasFrecuentes";
import { Preventa } from "./views/Preventa";
import { Header } from './components/Header.jsx';
import { Footer } from './components/Footer.jsx';
/**Components */
import ScrollToTop from "./components/ScrollToTop";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

/**Styles */
import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';
import 'swiper/css/navigation'; 
import 'swiper/css/autoplay';
import 'react-loading-skeleton/dist/skeleton.css';
import './App.css';
import { Checkout } from "./views/Checkout";
import { useEffect, useState } from "react";
import { CheckOutCart } from "./components/CheckOutCart.jsx";
import { ConfirmReserva } from "./views/ConfirmReserva.jsx";

function App() {
  const [dataSession, setDataSession] = useState(JSON.parse(sessionStorage.getItem('datosReserva')));
  const location = useLocation();
  useEffect(() => { 
    setDataSession(JSON.parse(sessionStorage.getItem('datosReserva'))) 
  }, [location.search]);
  return (
    <div className="App">
      {location.pathname !== "/reserva/confirmada" && (
              <Header />
            )}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={ <Home /> } />
        <Route path="/alojamientos" element={ <Alojamientos /> } />
        <Route path="/destinos" element={ <Destinos /> } />
        <Route path="/hotel" element={ <Hotel /> } />
        <Route path="/circuitos" element={ <Circuitos /> } />
        <Route path="/promociones" element={ <Promociones /> } />
        <Route path="/cursos" element={ <Cursos /> } />                
        <Route path="/cruceros" element={ <Cruceros /> } />
        <Route path="/sandals" element={ <Sandals /> } />
        <Route path="/mesa-de-regalos" element={ <MesaRegalos /> } />
        <Route path="/seguro-de-viajero" element={ <SeguroViajero /> } />
        <Route path="/xv-años" element={ <XvAños /> } />
        <Route path="/preventa" element={<Preventa />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/reserva/confirmada" element={<ConfirmReserva />} />
        <Route path="/nosotros" element={ <Nosotros /> } />
        <Route path="/contacto" element={ <Contacto /> } />
        <Route path="/terminos-y-condiciones" element={ <Terminos /> } />
        <Route path="/avisos-de-privacidad" element={ <AvisoPrivacidad /> } />
        <Route path="/politica-de-cookies" element={ <PoliticaCookies /> } />
        <Route path="/preguntas-frecuentes" element={ <PreguntasFrecuentes /> } />
      </Routes>
      {dataSession?.hospedaje?.length > 0 && location.pathname !== '/checkout' && location.pathname !== '/reserva/confirmada' && location.pathname !== '/preventa' ? <CheckOutCart arrDatos={JSON.parse(sessionStorage.getItem('datosReserva'))} /> : <></>}
          {location.pathname !== "/reserva/confirmada" && (
        <Footer/>
      )}
      <WhatsAppFloat/>
    </div>
  );
}

export default App;
